module.exports = __webpack_public_path__ + "f513ef7ac3a3534b99ff2537560f8158.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Description/images/cloud.svg
// module id = 842E
// module chunks = 13